// removed by extract-text-webpack-plugin
module.exports = {"Error":"Error__PFkkE","big":"big__3xBIm"};